export enum StorageType {
  Local = 'Local',
  Session = 'Session'
}
